import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  doc,
  getDoc,
  addDoc,
  collection,
  serverTimestamp
} from "firebase/firestore";
import ResistanceSlider from "../components/ResistanceSlider";

export default function SubDetail() {
  const { id } = useParams();
  const [sub, setSub] = useState(null);

  useEffect(() => {
    const fetchSub = async () => {
      const docRef = doc(db, "subs", id);
      const docSnap = await getDoc(docRef);
      setSub(docSnap.data());
    };

    fetchSub();
  }, [id]);

  const handleTest = async (resistance) => {
    await addDoc(collection(db, "subtests"), {
      subId: id,
      resistance: Number(resistance),
      createdAt: serverTimestamp()
    });

    alert("Test submitted!");
  };

  if (!sub) return <p>Loading...</p>;

  return (
    <div>
      <h3>{sub.title}</h3>
      <p>{sub.content}</p>

      <ResistanceSlider onSubmit={handleTest} />
    </div>
  );
}